import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32906376"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container-fluid",
  id: "nav-div"
}
const _hoisted_2 = { class: "navbar navbar-expand-md bg-light navbar-light" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-toggle": "collapse",
  "data-target": "#collapsibleNavbar"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "collapsibleNavbar"
}
const _hoisted_6 = { class: "navbar-nav w-100" }
const _hoisted_7 = { class: "nav-item home" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("HOME")
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("BLOG POSTS")
const _hoisted_11 = {
  class: "nav-item",
  style: {"display":"flex"},
  id: "dropdown-menu"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { id: "dropbtn-menu" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-caret-down" })
], -1))
const _hoisted_13 = { class: "dropdown-menu-content" }
const _hoisted_14 = { id: "dropdown-menu-1" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Link 1")
const _hoisted_16 = { class: "dropdown-submenu-content" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Sub Link 1")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Sub Link 2")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Sub Link 3")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Sub Link 4")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Link 2")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Link 3")
const _hoisted_23 = {
  class: "nav-item",
  style: {"display":"flex"},
  id: "dropdown-menu-about"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { id: "dropbtn-menu-about" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-caret-down" })
], -1))
const _hoisted_25 = { class: "dropdown-menu-content" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Who We Are")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("What We Do")
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("CONTACT US")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "nav-item",
  style: {"display":"none"}
}, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link",
    href: "#",
    id: "signup"
  }, "SIGN UP")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("img", {
        src: '/assets/images/logo.png',
        style: {"width":"10%"},
        alt: "FinditSmart"
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              "active-class": "active",
              "exact-active-class": "active",
              to: "/home"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              "active-class": "active",
              to: "/blog"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createElementVNode("span", {
              class: _normalizeClass(["nav-link", { 'active': _ctx.isPackagesActive }]),
              style: {"cursor":"default"}
            }, "PACKAGES", 2),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", _hoisted_14, [
                  _createVNode(_component_router_link, {
                    to: "/packages/link1",
                    "active-class": "active-submenu",
                    class: "dropdown-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }),
                  _createElementVNode("ul", _hoisted_16, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/packages/link1/sublink1",
                        "active-class": "active-submenu",
                        class: "dropdown-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/packages/link1/sublink2",
                        "active-class": "active-submenu",
                        class: "dropdown-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_18
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/packages/link1/sublink3",
                        "active-class": "active-submenu",
                        class: "dropdown-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/packages/link1/sublink4",
                        "active-class": "active-submenu",
                        class: "dropdown-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/packages/link2",
                    "active-class": "active-submenu",
                    class: "dropdown-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/packages/link3",
                    "active-class": "active-submenu",
                    class: "dropdown-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_23, [
            _createElementVNode("span", {
              class: _normalizeClass(["nav-link", { 'active': _ctx.isAboutActive }]),
              style: {"cursor":"default"}
            }, "ABOUT US", 2),
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/page/who-we-are",
                    class: _normalizeClass(["dropdown-link", { 'active-submenu': _ctx.isWhoWeAreActive }])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_26
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/page/what-we-do",
                    class: _normalizeClass(["dropdown-link", { 'active-submenu': _ctx.isWhatWeDoActive }])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_27
                    ]),
                    _: 1
                  }, 8, ["class"])
                ])
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_28, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              "active-class": "active",
              to: "/itenary"
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            })
          ]),
          _hoisted_30
        ])
      ])
    ])
  ]))
}